import _ from 'lodash';

import { preloadIdentity } from '@nerdwallet/js-auth-tools/actions';

import { bootstrapApp } from '../lib/actions';

const baseUri = process.env.BASE_URI;

const DataDependencies = [
  {
    path: baseUri,
    loadData: ({ store, req, res }, callback) => {
      const data = _.get(res, 'locals.data');
      if (data) {
        store.dispatch(preloadIdentity(data, req, res));
      }
      callback();
    },
    routes: [
      {
        path: `${baseUri}press`,
        loadData: ({ store, req }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'press-page',
              callback,
              query: req.query,
            })
          );
        },
      },
      {
        path: `${baseUri}specialists`,
        loadData: ({ store }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'specialists-page',
              callback,
            })
          );
        },
      },
      {
        path: `${baseUri}news`,
        loadData: ({ store }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'headlines',
              callback,
            })
          );
        },
      },
      {
        path: `${baseUri}careers/job/:id`,
        loadData: ({ store, match, res }, callback) => {
          const baseUrl = process.env.SITE_BASE_URL;
          store.dispatch(
            bootstrapApp({
              name: 'job-page',
              callback: () => {
                const jobMeta = _.get(store.getState(), 'careersData.job', {});
                _.update(res, 'locals.nerdlayout.dynamicMeta', (meta = []) =>
                  meta.concat(
                    {
                      property: 'og:url',
                      content: baseUrl.concat(
                        _.get(jobMeta, 'relativePath', '')
                      ),
                    },
                    {
                      property: 'og:title',
                      content: _.get(jobMeta, 'title', ''),
                    }
                  )
                );
                callback();
              },
              params: match.params,
            })
          );
        },
      },
      {
        path: `${baseUri}careers/:slug`,
        loadData: ({ store, match }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'department-page',
              callback,
              params: match.params,
            })
          );
        },
      },
      {
        path: `${baseUri}careers`,
        loadData: ({ store }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: 'careers-page',
              callback,
            })
          );
        },
      },
      {
        path: `${baseUri}`,
        loadData: ({ store, req }, callback) => {
          store.dispatch(
            bootstrapApp({
              name: '/',
              callback,
              req,
            })
          );
        },
      },
    ],
  },
];

export default DataDependencies;
